// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"06c56bf1","161":"91c40143","208":"e6659126","341":"06c56bf1","531":"c4555608","607":"58f24c01","780":"16f715b5","830":"fc3ff0dd","887":"558e0878"}[chunkId] + ".chunk.css";
};